export function createNullArray(length: number) {
  return Array.from({ length }, () => null);
}
